module.exports = __webpack_public_path__ + "static/media/government.127d9e28.svg";